import { render, staticRenderFns } from "./VsfPaymentProvider.vue?vue&type=template&id=7d8c3048&scoped=true"
import script from "./VsfPaymentProvider.vue?vue&type=script&lang=ts"
export * from "./VsfPaymentProvider.vue?vue&type=script&lang=ts"
import style0 from "./VsfPaymentProvider.vue?vue&type=style&index=0&id=7d8c3048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c3048",
  null
  
)

export default component.exports